import React, {useState, useEffect} from "react";



export default function EditPanelInputTextArea({thisRef}){
	
	
	
	useEffect(() => {
	
	}, []);
	
	const thisStyle = {
		display:"flex",
		width:"300px",
		height:"100px",
		paddingLeft:"10px",
		border:"1px solid #999",
		color:"black",
		backgroundColor:"rgba(0,0,0,0)",
		borderRadius:"4px",
		fontSize:"12px",
		fontFamily:"helvetica"
	};
	
	return (
		<textarea style={thisStyle} ref={thisRef}/>
	);
}